const copyNewForm = function(form){
	 let jsonStr = JSON.stringify(form);
	 let newForm = JSON.parse(jsonStr);
	 return newForm;
};

/*文件对象*/
const allowUploadTypes = function(fileType,allowTypes){
	let allowUpload = false;
	for(let i=0;i<allowTypes.length;i++){
		if(fileType == allowTypes[i]){
			allowUpload = true;
			break;
		}
	}
	
	return allowUpload;
};

export default {
	copyNewForm,
	allowUploadTypes
}